export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/translation.a7085dd.svg";